// Arrange Free React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";

import React, { useState, useEffect, useCallback } from "react";
import { DatePicker, Modal } from "antd";
import Loader from "layouts/loader/Loader";
import NontAuthorized401 from "NontAuthorized401";
import { utils, writeFile } from "xlsx";
import { toast, Toaster } from "react-hot-toast";
import Pagination from "components/pagination";
import AddLeadForm from "layouts/interior-leads/component/AddLeadForm";
import { apiCall } from "utils/apiClient";


function ContactLeads() {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalPages, setTotalPage] = useState(0)
  const [totalRecords, setTotalRecords] = useState(0)

  const [dateRange, setDateRange] = useState([null, null]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [fullMessage, setFullMessage] = useState("");
  const [lead, setLead] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    listLeads()
  }, [])

  // Effect to trigger API when search changes
  useEffect(() => {
    listLeads(1, recordsPerPage, dateRange[0], dateRange[1], debouncedSearch); // Reset to page 1 on search
  }, [debouncedSearch]);

  const listLeads = async (page = 1, limit = recordsPerPage, startDate = dateRange[0], endDate = dateRange[1], query = debouncedSearch) => {
    // setLoading(true);

    // Format dates to YYYY-MM-DD (if available)
    const formattedStartDate = startDate ? new Date(startDate).toISOString().split('T')[0] : null;
    const formattedEndDate = endDate ? new Date(endDate).toISOString().split('T')[0] : null;

    try {
      const result = await apiCall({ endpoint: "customer/getAllContactUs", method: "POST", data: { start_date: formattedStartDate, end_date: formattedEndDate, page, limit, search: query } });
      if (result.status === 200) {
        setLead(result.data);
        setCurrentPage(result.pagination.current_page);
        setTotalRecords(result.pagination.total_records);
        setTotalPage(result.pagination.total_pages);
        setLoading(false);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const handleViewClick = (message) => {
    setFullMessage(message);
    setModalVisible(true);
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const exportToExcel = () => {
    const table = document.getElementById("table-to-export");
    const workbook = utils.table_to_book(table, { sheet: "tablexls" });
    writeFile(workbook, "Contacts_Leads_Sheet.xlsx");
  };

  const handleDateRangeChange = (dates) => {
    if (dates) {
      setDateRange(dates);

      if (dates[0] && dates[1]) {
        const startDate = dates[0].toISOString().split('T')[0]; // Format to YYYY-MM-DD
        const endDate = dates[1].toISOString().split('T')[0];   // Format to YYYY-MM-DD

        // Call API with updated date range and pagination
        listLeads(currentPage, recordsPerPage, startDate, endDate);
      }
    } else {
      listLeads(currentPage, recordsPerPage, null, null);
    }
  };

  const handlePageChange = (number) => {
    listLeads(number, recordsPerPage, dateRange[0], dateRange[1]);
    setCurrentPage(number);

    // Call API with updated page number and date range
  };

  // Handle records per page changes
  const handleRecordsPerPageChange = (value) => {
    listLeads(1, value, dateRange[0], dateRange[1]);
    setRecordsPerPage(value);
    setCurrentPage(1); // Reset to first page when records per page change

    // Call API with updated records per page and date range
  };

  const handleSearchChange = useCallback(
    debounce((value) => setDebouncedSearch(value), 500),
    []
  );

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await apiCall({ endpoint: "customer/contact-us/query", method: "POST", data: { name: formData.name, contact_number: formData.phone, email_id: formData.email, message: formData.message, status: 1 } });
      if (result.status === 200) {
        toast.success("Lead added successfully!");
        listLeads();
        setFormData({ name: "", phone: "", email: "", message: "" });
      } else {
        alert("Failed to add lead.");
      }
    } catch (error) {
      console.error("Error adding lead:", error);
      alert("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const getLeadMessage = (leadItem) => {
    const messageValue =
      leadItem?.message ??
      leadItem?.query_message ??
      leadItem?.query ??
      leadItem?.description ??
      leadItem?.comment ??
      "";

    return typeof messageValue === "string"
      ? messageValue.trim()
      : String(messageValue || "");
  };

  return (
    <>
      {localStorage.getItem("Token") ? (
        <DashboardLayout>
          <Toaster position="top-center" reverseOrder={false} />
          <DashboardNavbar />
          {loading ? (
            <>
              <div className="relative bg-white h-screen overflow-hidden" />
              {loading && (
                <div className="flex justify-center">
                  <div className="absolute top-[30%]">
                    <Loader />
                  </div>
                </div>
              )}
            </>
          ) : (
            <div>
              <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <AddLeadForm formData={formData} handleChange={handleChange} handleSubmit={handleSubmit} loading={loading} />
                <div className="flex items-center justify-between gap-4 p-4">
                  {/* Search Input */}
                  <div className="flex-1">
                    <input
                      type="text"
                      id="simple-search"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
                      placeholder="Search expenses..."
                      required
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        handleSearchChange(e.target.value);
                      }}
                    />
                  </div>

                  {/* Date Picker */}
                  <div className="flex items-center">
                    <DatePicker.RangePicker
                      onChange={handleDateRangeChange}
                      format="YYYY-MM-DD"
                      className="w-full"
                    />
                  </div>

                  {/* Export & Pagination Section */}
                  <div className="flex items-center gap-4">
                    {/* Export Button */}
                    <button
                      onClick={exportToExcel}
                      className="bg-green-500 hover:bg-green-700 text-white font-bold px-4 py-2 rounded"
                    >
                      Export to Excel
                    </button>


                  </div>
                  {/* Pagination */}
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    recordsPerPage={recordsPerPage}
                    onRecordsPerPageChange={handleRecordsPerPageChange}
                    totalRecords={totalRecords}
                    count={lead?.length}
                  showFirstLastControls
                  compact
                  />
                </div>

                <table
                  id="table-to-export"
                  className="w-full text-sm text-left text-gray-500 dark:text-gray-400"
                >

                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="px-6 py-3">
                        Sr No
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Name
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Email
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Phone No.
                      </th>
                      <th scope="col" className="px-6 py-3">
                        City
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Space For
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Message
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Date / Time
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {lead.map((el, index) => {
                      const message = getLeadMessage(el);
                      const shortMessage = message.split(" ").slice(0, 10).join(" ");
                      const shouldShowView = message.length > shortMessage.length;

                      return (
                        <tr
                          key={el.id}
                          className={`border-b dark:bg-gray-800 dark:border-gray-700 ${index % 2 === 0
                            ? "odd:bg-white even:bg-gray-50"
                            : "odd:dark:bg-gray-800 even:dark:bg-gray-700"
                            }`}
                        >
                          <th
                            scope="row"
                            className="px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap"
                          >
                            {/* {(currentPage - 1) * itemsPerPage + index + 1} */}
                            {index + 1}
                          </th>
                          <td className="px-6 py-4">
                            <a>{el.name}</a>
                          </td>
                          <td className="px-6 py-4 ">{el.email_id}</td>
                          <td className="px-6 py-4 ">{el.contact_number}</td>
                          <td className="px-6 py-4 ">{el.city}</td>
                          <td className="px-6 py-4 ">{el.space_type}</td>
                          <td
                            className="px-6 py-4"
                            style={{ wordWrap: "break-word", maxWidth: "240px" }}
                          >
                            {shortMessage || "-"}
                            {shouldShowView && (
                              <button
                                className="ml-2 text-blue-500 underline"
                                onClick={() => handleViewClick(message)}
                              >
                                View
                              </button>
                            )}
                          </td>
                          <td className="px-6 py-4 ">{el.created_at}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <Modal
                  title="Message"
                  open={modalVisible}
                  onCancel={() => setModalVisible(false)}
                  footer={null}
                  maskStyle={{ backgroundColor: "transparent" }}
                >
                  <p>{fullMessage || "-"}</p>
                </Modal>
              </div>
              {/* <div className="flex justify-center mt-4">
        <div className="flex">
          {(currentPage === 1) ? '' : <button
            onClick={() => paginate(currentPage - 1)}
            className={`px-3 mx-3 rounded-md w-[110px] focus:outline-none bg-black text-white text-md ${currentPage === 1 ? 'cursor-not-allowed' : ''}`}
          // disabled={currentPage === 1}
          >
            Previous
          </button>}
          {(currentPage !== pageCount) ? <button
            onClick={() => paginate(currentPage + 1)}
            className={`px-3 mx-3 rounded-md w-[110px] focus:outline-none bg-black text-white text-md ${currentItems.length < itemsPerPage ? 'cursor-allowed' : ''}`}
          // disabled={currentItems.length < itemsPerPage}
          >
            Next
          </button> : ""}

        </div>
      </div> */}
            </div>
          )}
          {/* <Footer /> */}
        </DashboardLayout>
      ) : (
        <NontAuthorized401 />
      )}
    </>
  );
}

export default ContactLeads;
